import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18.03 17.94"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#4EBC73" }, [
      _createElementVNode("path", { d: "M0 6.05v9.11a2.86 2.86 0 0 0 1.6 2.48c.368.17.765.272 1.17.3h12.389999999999999a3.3 3.3 0 0 0 1.17-.3 2.86 2.86 0 0 0 1.6-2.48V6.05zm5 6.92a1 1 0 1 1 0-2.001 1 1 0 0 1 0 2.001m0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4 4a1 1 0 1 1 0-2.001 1 1 0 0 1 0 2.001m0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2M17.96 4.77a3 3 0 0 0-.29-1.16A2.85 2.85 0 0 0 15.19 2H14V1a1 1 0 1 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2.8a3.1 3.1 0 0 0-1.17.29A3 3 0 0 0 .32 3.61a3 3 0 0 0-.29 1.16v1.28h18c-.04-.49-.04-.92-.07-1.28" })
    ], -1)
  ]))]))
}
export default { render: render }